<div class="field-editor" [class.expanded]="expanded">
  <div class="field-header" (click)="expanded = !expanded">
    <span class="field-summary">
      <strong>{{field.name || '(unnamed field)'}}</strong>
      <span class="field-path">{{field.path}}</span>
      <span class="field-type">{{field.type || 'string'}}</span>
    </span>
    <span class="field-actions" (click)="$event.stopPropagation()">
      <button class="button small" [disabled]="index === 0" (click)="moveUp.emit()">▲</button>
      <button class="button small" [disabled]="index === count - 1" (click)="moveDown.emit()">▼</button>
      <button class="button small red" (click)="remove.emit()">Remove</button>
      <button class="button small" (click)="expanded = !expanded">{{expanded ? 'Collapse' : 'Edit'}}</button>
    </span>
  </div>

  <div class="field-body" *ngIf="expanded">
    <div class="form-grid">
      <label>
        Path
        <input type="text" placeholder="document path, e.g. customer.name" [(ngModel)]="field.path" (change)="emitChanged()" />
      </label>
      <label>
        Display Name
        <input type="text" placeholder="display name" [(ngModel)]="field.name" (change)="emitChanged()" />
      </label>
      <label>
        Type
        <select [(ngModel)]="field.type" (change)="typeChanged()">
          <option [ngValue]="undefined">(default)</option>
          <option *ngFor="let fieldType of fieldTypes" [value]="fieldType">{{fieldType}}</option>
        </select>
      </label>
    </div>

    <div class="flag-row">
      <label class="flag">
        <app-toggle [checked]="!!field.calculated" (valueChanged)="toggleCalculated($event)"></app-toggle>
        Calculated
      </label>
      <label class="flag">
        <app-toggle [checked]="!!field.locationSpecific" (valueChanged)="setFlag('locationSpecific', $event)"></app-toggle>
        Location Specific
      </label>
      <ng-container *ngIf="mode === 'report'">
        <label class="flag">
          <app-toggle [checked]="!!field.total" (valueChanged)="setFlag('total', $event)"></app-toggle>
          Total
        </label>
        <label class="flag">
          <app-toggle [checked]="!!field.count" (valueChanged)="setFlag('count', $event)"></app-toggle>
          Count
        </label>
      </ng-container>
      <ng-container *ngIf="mode === 'view'">
        <label class="flag">
          <app-toggle [checked]="!!field.editable" (valueChanged)="setFlag('editable', $event)"></app-toggle>
          Editable
        </label>
        <label class="flag">
          <app-toggle [checked]="!!field.required" (valueChanged)="setFlag('required', $event)"></app-toggle>
          Required
        </label>
        <label class="flag">
          <app-toggle [checked]="!!field.suggestValues" (valueChanged)="setFlag('suggestValues', $event)"></app-toggle>
          Suggest Values
        </label>
        <!-- Array (limit) fields only: chips drag-reorder in the detail view -->
        <label class="flag" *ngIf="field.limit">
          <app-toggle [checked]="!!field.sortable" (valueChanged)="setFlag('sortable', $event)"></app-toggle>
          Sortable
        </label>
        <!-- Array fields where [] has its own meaning (servesLocationId): an
             emptied list removes the field instead of storing [] -->
        <label class="flag" *ngIf="mode === 'view' && field.limit">
          <app-toggle [checked]="!!field.emptyUnsets" (valueChanged)="setFlag('emptyUnsets', $event)"></app-toggle>
          Empty List Removes Field
        </label>
      </ng-container>
    </div>

    <div class="form-grid" *ngIf="field.calculated">
      <label class="wide">
        Formula
        <input type="text" placeholder="e.g. $price * $qty" [(ngModel)]="field.formula" (change)="emitChanged()" />
      </label>
    </div>

    <div class="form-grid" *ngIf="mode === 'report'">
      <label>
        Column Width (px)
        <input type="number" [ngModel]="field.width" (ngModelChange)="setNumber('width', $event)" />
      </label>
      <label>
        Instant Edit Permission
        <input type="text" placeholder="permission key" [ngModel]="field.instantEditPermission" (ngModelChange)="setText(field, 'instantEditPermission', $event)" />
      </label>
      <label>
        Instant Edit Save Path
        <input type="text" placeholder="API route" [ngModel]="field.instantEditSavePath" (ngModelChange)="setText(field, 'instantEditSavePath', $event)" />
      </label>
    </div>

    <div class="form-grid" *ngIf="mode === 'view'">
      <label>
        Import Aliases
        <input type="text" placeholder="comma-separated column names" [(ngModel)]="aliasText" (change)="aliasChanged()" />
      </label>
      <label>
        Array Limit
        <input type="number" [ngModel]="field.limit" (ngModelChange)="setNumber('limit', $event)" />
      </label>
      <label>
        Conditional Path
        <input type="text" placeholder="only populate when this path has a value" [ngModel]="field.conditionalPath" (ngModelChange)="setText(field, 'conditionalPath', $event)" />
      </label>
      <label class="wide" *ngIf="mode === 'view' && field.limit">
        Empty Hint
        <input type="text" placeholder="shown when the list is empty, e.g. Serves all locations" [ngModel]="field.emptyHint" (ngModelChange)="setText(field, 'emptyHint', $event)" />
      </label>
      <label class="wide" *ngIf="!field.type || field.type === 'string'">
        Options
        <input type="text" placeholder="comma-separated values; editors show a dropdown limited to these" [(ngModel)]="optionsText" (change)="optionsChanged()" />
      </label>
    </div>

    <!-- Boolean value mapping: store something other than true/false (e.g. a
         "Kitchen Printer" toggle over the legacy printer string: on = kitchen,
         off = empty). Blank = plain true/false. -->
    <div class="row" *ngIf="mode === 'view' && field.type === 'boolean'">
      <label>
        Stored value when ON
        <input type="text" placeholder="blank = true" [(ngModel)]="trueValueText" (change)="booleanValuesChanged()" />
      </label>
      <label>
        Stored value when OFF
        <input type="text" placeholder="blank = null when ON value is set, else false" [(ngModel)]="falseValueText" (change)="booleanValuesChanged()" />
      </label>
    </div>

    <div class="sub-section" *ngIf="showDetailLink">
      <h4>Detail Link</h4>
      <div class="form-grid">
        <label>
          Route
          <input type="text" placeholder="legacy detail route, e.g. customer" [ngModel]="field.route" (ngModelChange)="setText(field, 'route', $event)" />
        </label>
        <label>
          Id Path
          <input type="text" placeholder="document path holding the id, e.g. customerId" [ngModel]="field.localPath" (ngModelChange)="setText(field, 'localPath', $event)" />
        </label>
      </div>
    </div>

    <div class="sub-section" *ngIf="showNotes">
      <h4>Notes</h4>
      <div class="form-grid">
        <label>
          Note Type
          <input type="text" placeholder="permission scope, e.g. transaction" [ngModel]="field.noteType" (ngModelChange)="setText(field, 'noteType', $event)" />
        </label>
      </div>
    </div>

    <div class="sub-section" *ngIf="showRemoteJoin">
      <h4>Remote Join</h4>
      <div class="form-grid">
        <label>
          Remote Collection
          <input type="text" [ngModel]="field.remoteCollection" (ngModelChange)="setText(field, 'remoteCollection', $event)" />
        </label>
        <label>
          Remote Field
          <input type="text" [ngModel]="field.remoteField" (ngModelChange)="setText(field, 'remoteField', $event)" />
        </label>
        <label>
          Local Path
          <input type="text" placeholder="defaults to path" [ngModel]="field.localPath" (ngModelChange)="setText(field, 'localPath', $event)" />
        </label>
      </div>
    </div>

    <div class="sub-section" *ngIf="showSource && field.source">
      <h4>Source Collection</h4>
      <div class="form-grid">
        <label>
          Collection
          <input type="text" [(ngModel)]="field.source.collection" (change)="emitChanged()" />
        </label>
        <label>
          Join Path
          <input type="text" placeholder="usually _id" [(ngModel)]="field.source.path" (change)="emitChanged()" />
        </label>
        <label>
          Display Path(s)
          <input type="text" placeholder="comma-separated paths" [(ngModel)]="displayPathText" (change)="displayPathChanged()" />
        </label>
        <label>
          Local Path
          <input type="text" placeholder="defaults to join path" [ngModel]="field.source.localPath" (ngModelChange)="setText(field.source, 'localPath', $event)" />
        </label>
      </div>
      <div class="sub-section">
        <h4>Source Filters</h4>
        <app-key-value-editor [data]="field.source.filters" keyPlaceholder="field path"
          (dataChange)="sourceFiltersChanged($event)"></app-key-value-editor>
      </div>
      <div class="sub-section" *ngIf="mode === 'view'">
        <h4>Cache Fields</h4>
        <div class="cache-field-row" *ngFor="let cacheField of field.cacheFields; let i = index">
          <input type="text" placeholder="source path" [(ngModel)]="cacheField.sourcePath" (change)="emitChanged()" />
          <input type="text" placeholder="cache path" [(ngModel)]="cacheField.cachePath" (change)="emitChanged()" />
          <button class="button small red" (click)="removeCacheField(i)">Remove</button>
        </div>
        <button class="button small" (click)="addCacheField()">Add Cache Field</button>
      </div>
    </div>

    <div class="sub-section" *ngIf="mode === 'view'">
      <label class="flag">
        <app-toggle [checked]="!!field.remoteLookup" (valueChanged)="toggleRemoteLookup($event)"></app-toggle>
        Remote Lookup (FireTower)
      </label>
      <div class="form-grid" *ngIf="field.remoteLookup">
        <label>
          Local Lookup Key
          <input type="text" [(ngModel)]="field.remoteLookup.lookupKeyLocal" (change)="emitChanged()" />
        </label>
        <label>
          Remote Lookup Key
          <input type="text" [(ngModel)]="field.remoteLookup.lookupKeyRemote" (change)="emitChanged()" />
        </label>
        <label>
          Remote Field Key
          <input type="text" [(ngModel)]="field.remoteLookup.remoteFieldKey" (change)="emitChanged()" />
        </label>
      </div>
    </div>
  </div>
</div>
